export default __webpack_public_path__ + "static/media/Frame (1).ca38bc82.png";